import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { userApi, apiError } from "@/lib/userApi";
import { useUserAuth } from "@/context/UserAuthContext";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { CircuitBg } from "@/components/CircuitBg";
import { GlassField, GlassButton } from "@/components/GlassBits";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);
  const { signIn } = useUserAuth();
  const navigate = useNavigate();

  const submit = async () => {
    if (password.length < 8) return toast.error("La contraseña necesita al menos 8 caracteres");
    if (password !== again) return toast.error("Las contraseñas no coinciden");
    setBusy(true);
    try {
      const { data } = await userApi.post("/user/auth/reset-password", { token, password });
      signIn(data.user);
      toast.success("Contraseña actualizada");
      navigate("/panel");
    } catch (e) {
      toast.error(apiError(e, "No se pudo restablecer la contraseña"));
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center circuit-bg theme-noir" style={{ backgroundColor: "#05070C" }}>
      <CircuitBg />
      <div className="circuit-veil" aria-hidden="true" />
      <div className="w-full max-w-md px-6 animate-fade-up">
        <div className="flex flex-col items-center mb-7" style={{ textShadow: "0 2px 18px rgba(0,0,0,0.9)" }}>
          <img src="/logo-digital-forge.jpg" alt="Digital Forge" data-testid="brand-logo"
            className="w-20 h-20 rounded-full object-cover mx-auto mb-4 border border-white/10"
            style={{ boxShadow: "0 0 46px rgba(255,138,43,0.35)" }} />
          <div className="font-heading text-[11px] tracking-[0.34em] text-amber-300/80 mb-1.5">DIGITAL FORGE</div>
          <h1 className="font-heading text-2xl font-bold text-white">Nueva contraseña</h1>
        </div>
        <div className="glass-card p-7" data-testid="reset-card">
          {!token ? (
            <p className="text-sm text-white/70">
              Enlace inválido. Pide otro desde{" "}
              <Link to="/acceso" className="text-red-400">la pantalla de acceso</Link>.
            </p>
          ) : (
            <>
              <div className="flex items-center gap-2 text-white/80 text-sm mb-5">
                <ShieldCheck className="w-4 h-4 text-red-400" /> Elige tu contraseña nueva
              </div>
              <div className="space-y-4">
                <GlassField data-testid="reset-password-input" label="Contraseña" type="password"
                  value={password} placeholder="Mínimo 8 caracteres"
                  onChange={(e) => setPassword(e.target.value)} />
                <GlassField data-testid="reset-password-again" label="Repite la contraseña" type="password"
                  value={again} placeholder="••••••••" onChange={(e) => setAgain(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && submit()} />
              </div>
              <GlassButton data-testid="reset-submit-btn" tone="red" className="mt-6" loading={busy}
                onClick={submit}>Guardar y entrar</GlassButton>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
